
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"15 15 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-9.2%","y":"-45.1%","width":"118.5%","height":"198.9%","filterUnits":"objectBoundingBox","id":"a"}},[_c('feOffset',{attrs:{"dy":".2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"7.5","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.117706512 0","in":"shadowBlurOuter1","result":"shadowMatrixOuter1"}}),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"shadowMatrixOuter1"}}),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})])])]),_c('g',{attrs:{"transform":"translate(-314 -10)","fill":"#FFF","filter":"url(#a)","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M341 40.908c-.71 0-1.228-.554-1.228-1.32 0-.763.518-1.318 1.229-1.318.722 0 1.227.542 1.227 1.319 0 .765-.517 1.319-1.227 1.319zm1.027-13.361l-.268 9.592h-1.517l-.268-9.592h2.053zM330.754 25c-.94 0-1.7.783-1.7 1.748v12.68L329 49l5.36-5.47h16.94c.94 0 1.7-.782 1.7-1.747V26.748c0-.965-.76-1.748-1.7-1.748h-20.546z"}})])])
          )
        }
      }
    